<template>
    <div class="canku">
        <h1 class="crumb">已发货列表</h1>
        <div class="bar">
            <div class="btnGroup">
                <span style="">下单日期　</span>
                <el-date-picker
                    v-model="installDate"
                    type="daterange"
                    range-separator="至"
                    @change="getDataList"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <el-select v-model="ssgn" placeholder="请选择" style="width: 150px;margin-left: 50px">
                    <el-option
                        v-for="item in ssgnSelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer"
                    >
                    </el-option>
                </el-select>
                <span><el-input v-model="searchKey" style="width: 200px" placeholder="请输入"></el-input></span>
                <el-button class="btn" @click="getDataList" style="">搜索</el-button>
            </div>
        </div>
        <!--<img src="http://api.k780.com/?app=barcode.get&bc_text=18F01801&appkey=10003&sign=b59bc3ef6191eb9f747dd4e83c99f2a4">-->
        <el-table :data="tableData">
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="props">
                    <el-button type="text" style="width: 40%;margin-left: 0;" @click="Dayin(props.row)">打印</el-button>
                    <el-button type="text" style="width: 40%;margin-left: 0;" @click="FahuoReturn(props.row)">返回发货</el-button>
                    <el-button type="text" style="width: 40%;margin-left: 0;" @click="Tuihuo(props.row)">退货</el-button>
                    <el-button type="text" style="width: 40%;margin-left: 0;" @click="Beizhu(props.row)">备注</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="return_status" label="订单状态" :formatter="Status" align="center"></el-table-column>
            <el-table-column prop="department" label="销售部门" align="center"></el-table-column>
            <el-table-column prop="made_person" label="下单员" align="center"></el-table-column>
            <el-table-column prop="order_number" label="提货单号" align="center"></el-table-column>
            <el-table-column prop="contract_number" label="合同订单号" align="center"></el-table-column>
            <el-table-column label="型号" align="center" width="120">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods">{{item.model}}</div>
                </template>
            </el-table-column>
            <el-table-column label="数量" align="center" width="60">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods">{{item.goods_num}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="customer" label="客户姓名" align="center"></el-table-column>
            <el-table-column prop="phone" label="客户电话" align="center"></el-table-column>
            <el-table-column prop="address" label="客户地址" align="center"></el-table-column>
            <el-table-column prop="transport_way" label="送货方式" align="center"></el-table-column>
            <el-table-column prop="logistics_company" label="安装公司/物流/司机" width="150" align="center"></el-table-column>
            <el-table-column prop="remarks" label="备注" align="center"></el-table-column>
            <el-table-column prop="note" label="仓库备注" align="center"></el-table-column>
            <el-table-column prop="arrival_time" label="预约日期" align="center"></el-table-column>
            <el-table-column prop="addtime" label="下单日期" :formatter="formatter" align="center"></el-table-column>
        </el-table>
        <el-dialog
            :visible.sync="showBeizhu"
            title="添加备注">
            <el-form :model="form">
                <el-form-item label="备注:" :label-width="formLabelWidth">
                    <el-input v-model="form.beizhu" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showBeizhu = false">取 消</el-button>
                <el-button type="primary" @click="qrBeizhu">确 定</el-button>
            </span>
        </el-dialog>
        <el-pagination
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
    import qs from 'qs'
    export default {
        data() {
            return {
                tableData: [],
                showBeizhu: false,
                formLabelWidth: '80px',
                page: 1,
                total: '',
                form: {
                    beizhu: '',
                    id: '',
                },
                installDate: '',
                ssgnSelect: [{name: '提货单号', referer: 'order_number'}, {name: '客户电话', referer: 'phone'}, {name: '送货方式', referer: 'transport_way'}, {name: '物流', referer: 'logistics_company'}],
                ssgn: 'order_number',
                searchKey: '',
            }
        },
        created() {
            this.getDataList()
        },
        methods: {
            formatter(row) {
                return new Date(row.addtime * 1000).toLocaleDateString().toString().replace(/\//g, '-')
            },
            Status(row) {
                if (row.return_status === '0') {
                    return '发货'
                } return '退货'
            },
            getDataList() {
                let datas = {}
                if (this.installDate) {
                    console.log(this.installDate)
                    datas.made_time1 = Date.parse(this.installDate[0].toLocaleDateString()).toString().slice(0, 10)
                    datas.made_time2 = +Date.parse(this.installDate[1].toLocaleDateString()).toString().slice(0, 10) + 60 * 60 * 24
                }
                if (this.searchKey !== '') {
                    if (this.ssgn === 'order_number') {
                        datas.order_number = this.searchKey
                    } else if (this.ssgn === 'phone') {
                        datas.phone = this.searchKey
                    } else if (this.ssgn === 'transport_way') {
                        datas.transport_way = this.searchKey
                    } else if (this.ssgn === 'logistics_company') {
                        datas.logistics_company = this.searchKey
                    }
                }
                this.$http.get(this.$reqUrl + `service.php?act=warehouse_list&status=1&page=${this.page}`, {params: datas}).then(res => {
                    this.tableData = res.data.list
                    this.total = res.data.count
                })
            },
            //打印
            Dayin(row) {
                localStorage.setItem('CangkuDayin2', JSON.stringify(row))
                let routeData2 = this.$router.resolve({
                    name: "CangkuDayin2",
                });
                window.open(routeData2.href, '_blank');
            },
            FahuoReturn(row) {
                this.$confirm('确认退回该订单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'success'
                }).then(() => {
                    let data = {
                        type: 'fahuo_return',
                        id: row.id
                    }
                    this.$http.post(this.$reqUrl + `service.php?act=warehouse_update`, qs.stringify(data)).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success('确认成功')
                            this.getDataList()
                        }
                    })
                })
            },
            //确认打印
            QrDayin(id) {
                this.$confirm('确认该订单为已打印?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'success'
                }).then(() => {
                    let data = {
                        type: 'print',
                        id: id
                    }
                    this.$http.post(this.$reqUrl + `service.php?act=warehouse_update`, qs.stringify(data)).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success('确认成功')
                            this.getDataList()
                        }
                    })
                })
            },
            Tuihuo(row) {
                this.$confirm('确认退货?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'success'
                }).then(() => {
                    let data = {
                        id: row.id
                    }
                    this.$http.post(this.$reqUrl + `service.php?act=warehouse_return`, qs.stringify(data)).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success('退货成功')
                            this.getDataList()
                        }
                    })
                })
            },
            Beizhu(row) {
                this.showBeizhu = true
                this.form.id = row.id
            },
            qrBeizhu() {
                let data = {
                    type: 'remark',
                    id: this.form.id,
                    remarks: this.form.beizhu
                }
                this.$http.post(this.$reqUrl + `service.php?act=warehouse_update`, qs.stringify(data)).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success('备注成功')
                        this.showBeizhu = false
                        this.getDataList()
                    }
                })
            },
            handleCurrentChange (val) {
                this.page = val
                this.getDataList()
            },
        }
    }
</script>

<style lang="less" scoped>
    .bar {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        button {
            width: 100Px;
            height: 37Px;
            margin-right: 10Px;
            font-size: 16px;
            color: #ffffff;
            background: #f56c31;
            border-radius: 2px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/router/Cangku2.vue